import script from "./AppIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AppIcon.vue?vue&type=script&setup=true&lang=js"

import "./AppIcon.vue?vue&type=style&index=0&id=d23459b2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d23459b2"]])

export default __exports__